import { ModalProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { Dialog } from '@te-whatu-ora/anatomic'
import { ReactNode, useEffect, useState } from 'react'
import {
  IntersectionMeasurement,
  MeasureIntersection
} from '@/components/shared/intersection'
import { useEmbed } from '@/contexts/embed/embed'
import { Show } from '@/components/show'

interface BaseModalProps extends Omit<ModalProps, 'formItems'> {
  children: ReactNode
}

export function BaseModal({ children, onClose, title }: BaseModalProps) {
  const { isEmbedded } = useEmbed()
  const [measurement, setMeasurement] = useState<IntersectionMeasurement>()

  // When embedded, the iframe is as tall as the whole form, so the dialog must be
  // repositioned into the part of the iframe that is actually visible to the user
  useEffect(() => {
    if (!isEmbedded) return
    if (!measurement) return

    // Anatomic doesn't pass a ref through to the modal so we have to rely on querying
    const modal = document.querySelector(
      "[role='dialog']._1iolpaq1"
    ) as HTMLDivElement
    if (!modal) return

    modal.style.top = `${measurement.offset + measurement.height / 2}px`
  }, [isEmbedded, measurement])

  // The renderer only mounts a modal when it should be visible, so the dialog can
  // simply start open.
  function handleOpenChange(open: boolean) {
    if (!open) onClose()
  }

  return (
    <>
      <Show when={isEmbedded}>
        <MeasureIntersection onMeasure={setMeasurement} />
      </Show>
      <Dialog.Root
        modal
        heading={title}
        defaultOpen
        onOpenChange={handleOpenChange}
      >
        <Dialog.Content>{children}</Dialog.Content>
      </Dialog.Root>
    </>
  )
}
